module.exports = __webpack_public_path__ + "img/espacioh-center.2cd49c21.png";